import Vue from 'vue';
import HighCharts from 'highcharts-vue';

Vue.use(HighCharts);
